export class ListInfo {

    public last: boolean;
    public totalElements: number;
    public totalPages: number;
    public sortDir: string;
    public sortField: string;
    public number: number;
    public numberOfElements: number;
    public first: boolean;
    public size: number;

    constructor(value: unknown) {
        this.last = value["last"];
        this.totalElements = value["totalElements"];
        this.totalPages = value["totalPages"];
        this.sortDir = value["sort"]["direction"];
        this.sortField = value["sort"]["property"];
        this.number = value["number"];
        this.numberOfElements = value["numberOfElements"];
        this.first = value["first"];
        this.size = value["size"];
    }
}
